import {Model} from './model';

export class InvoiceConfiguration implements Model {
  invoiceConfigurationId: number;
  name: string;

  static copy(oldObj: InvoiceConfiguration): InvoiceConfiguration {
    const newObj = new InvoiceConfiguration();
    newObj.invoiceConfigurationId = oldObj.invoiceConfigurationId;
    newObj.name = oldObj.name;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.invoiceConfigurationId;
  }

  isNew(): boolean {
    return isNaN(this.invoiceConfigurationId);
  }

  clone(): InvoiceConfiguration {
    return InvoiceConfiguration.copy(this);
  }
}
